module.exports = __webpack_public_path__ + "static/img/1_1_1.fee0ef1b.jpg";